import { ArrowRight, Phone } from "lucide-react";
import { Button } from "../ui/button";
import SectionLogo from "../SectionLogo";

export const FinalCTASection = ({ scrollToSection }) => {
  return (
    <section className="py-24 bg-[#0a0318] relative">
      <SectionLogo position="center" size="large" opacity={0.05} />
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <img
            src="/images/imc-shield.png"
            alt="Logo"
            className="w-32 h-32 object-contain mx-auto mb-8"
          />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Ready to <span className="text-amber-400">Recover</span>?
          </h2>
          <p className="text-gray-300 text-xl mb-8">
            Ice Man attacks pain and stubborn fat with purpose, precision, and the power of cold.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Button
              size="lg"
              onClick={() => scrollToSection("booking")}
              className="bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white px-8 py-6 text-lg"
              data-testid="final-cta-book-btn"
            >
              Book Now <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <a href="tel:8443423626">
              <Button
                size="lg"
                variant="outline"
                className="border-amber-500 text-amber-400 hover:bg-amber-500/20 px-8 py-6 text-lg"
                data-testid="final-cta-call-btn"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now
              </Button>
            </a>
          </div>
          <div className="space-y-2 text-gray-400">
            <p className="text-2xl font-bold text-amber-400">844-3ICEMAN</p>
            <p>844-342-3626</p>
            <p>www.icemancryo.com</p>
          </div>
        </div>
      </div>
    </section>
  );
};
